import images from "./images";

const menu = {
    herbalTea: [
        {
            id: 1,
            name: "Chamomile Tea",
            price: 20,
            description: "Soothing floral infusion known for calming effects and promoting better sleep.",
            image: images.herbalTea1,
        },
        {
            id: 2,
            name: "Peppermint Tea",
            price: 20,
            description: "Refreshing herbal tea that helps with digestion and relieves headaches.",
            image: images.herbalTea2,
        },
        {
            id: 3,
            name: "Ginger Tea",
            price: 20,
            description: "Spicy, warming tea known to aid digestion and reduce inflammation.",
            image: images.herbalTea3,
        },
        {
            id: 4,
            name: "Hibiscus Tea",
            price: 20,
            description: "Vibrant red tea rich in antioxidants and good for lowering blood pressure.",
            image: images.herbalTea4,
        },
        {
            id: 5,
            name: "Rooibos Tea",
            price: 20,
            description: "Naturally sweet and caffeine-free, packed with antioxidants and nutrients.",
            image: images.herbalTea5,
        },
        {
            id: 6,
            name: "Sage Tea",
            price: 20,
            description: "Earthy tea that supports cognitive function and soothes sore throats.",
            image: images.herbalTea6,
        },
        {
            id: 7,
            name: "Lemon Balm Tea",
            price: 20,
            description: "Mild citrusy tea known to reduce stress and improve sleep quality.",
            image: images.herbalTea7,
        },
        {
            id: 8,
            name: "Rose Hip Tea",
            price: 20,
            description: "Fruity, tangy tea rich in vitamin C and supports immune health.",
            image: images.herbalTea8,
        }
    ],
    chaiTea: [
        {
            id: 1,
            name: "Cardamom Chai",
            price: 20,
            description: "Fragrant chai infused with cardamom pods for a warm, aromatic flavor.",
            image: images.chaiTea1,
        },
        {
            id: 2,
            name: "Cinnamon Chai",
            price: 20,
            description: "Spicy-sweet chai tea brewed with bold cinnamon sticks and black tea.",
            image: images.chaiTea2,
        },
        {
            id: 3,
            name: "Chai Tea Latte",
            price: 20,
            description: "Creamy, spiced black tea blended with steamed milk and foam.",
            image: images.chaiTea3,
        },
        {
            id: 4,
            name: "Matka Chai",
            price: 20,
            description: "Traditional clay-pot brewed chai with bold flavor and rustic aroma.",
            image: images.chaiTea4,
        },
        {
            id: 5,
            name: "Tulsi Chai",
            price: 20,
            description: "Holistic chai with tulsi (holy basil), known for stress relief and immunity.",
            image: images.chaiTea5,
        },
        {
            id: 6,
            name: "Vanilla Chai",
            price: 20,
            description: "Smooth chai tea infused with soft vanilla notes for a sweet finish.",
            image: images.chaiTea6,
        },
        {
            id: 7,
            name: "Chai Espresso",
            price: 20,
            description: "A bold fusion of strong chai spices and a shot of rich espresso.",
            image: images.chaiTea7,
        },
        {
            id: 8,
            name: "Ginger Chai",
            price: 20,
            description: "Zesty and warming chai with freshly grated ginger and black tea.",
            image: images.chaiTea8,
        }
    ],
    greenTea: [
        {
            id: 1,
            name: "Matcha Green Tea",
            price: 20,
            description: "Finely ground green tea leaves whisked into a frothy, antioxidant-rich drink.",
            image: images.greenTea1,
        },
        {
            id: 2,
            name: "Sencha Green Tea",
            price: 20,
            description: "Classic Japanese green tea with a refreshing grassy flavor and vibrant aroma.",
            image: images.greenTea2,
        },
        {
            id: 3,
            name: "Shincha Green Tea",
            price: 20,
            description: "First flush green tea with a delicate sweetness and fresh spring notes.",
            image: images.greenTea3,
        },
        {
            id: 4,
            name: "Jasmine Green Tea",
            price: 20,
            description: "Delicate green tea infused with fragrant jasmine blossoms for a floral finish.",
            image: images.greenTea4,
        },
        {
            id: 5,
            name: "Longjing Green Tea",
            price: 20,
            description: "Also known as Dragon Well, this pan-roasted tea offers a nutty, smooth taste.",
            image: images.greenTea5,
        },
        {
            id: 6,
            name: "Gyokuro Green Tea",
            price: 20,
            description: "Shade-grown premium green tea known for its sweet, umami-rich flavor.",
            image: images.greenTea6,
        },
        {
            id: 7,
            name: "Mint Green Tea",
            price: 20,
            description: "Refreshing blend of green tea and cooling mint for a crisp, soothing sip.",
            image: images.greenTea7,
        },
        {
            id: 8,
            name: "Gunpowder Tea",
            price: 20,
            description: "Rolled green tea leaves that unfurl during brewing, offering a smoky, bold taste.",
            image: images.greenTea8,
        }
    ],
    blackTea: [
        {
            id: 1,
            name: "Masala Chai",
            price: 20,
            description: "Traditional Indian spiced black tea brewed with aromatic herbs and milk.",
            image: images.blackTea1,
        },
        {
            id: 2,
            name: "Chocolate Chai",
            price: 20,
            description: "A rich blend of black tea, spices, and decadent chocolate notes.",
            image: images.blackTea2,
        },
        {
            id: 3,
            name: "Yunnan Tea",
            price: 20,
            description: "Bold and earthy black tea from China’s Yunnan province with malty undertones.",
            image: images.blackTea3,
        },
        {
            id: 4,
            name: "Earl Gray Tea",
            price: 20,
            description: "Classic black tea infused with bergamot for a bright citrus aroma.",
            image: images.blackTea4,
        },
        {
            id: 5,
            name: "Turkish Tea",
            price: 20,
            description: "Strong, full-bodied black tea traditionally served in tulip-shaped glasses.",
            image: images.blackTea5,
        },
        {
            id: 6,
            name: "English Breakfast Tea",
            price: 20,
            description: "A robust blend of black teas perfect for a bold and energizing morning cup.",
            image: images.blackTea6,
        },
        {
            id: 7,
            name: "Nutty Black Tea",
            price: 20,
            description: "Smooth black tea with a subtle nutty finish and warm aroma.",
            image: images.blackTea7,
        },
        {
            id: 8,
            name: "Assam Black Tea",
            price: 20,
            description: "Strong Indian tea with a rich, malty flavor and deep amber hue.",
            image: images.blackTea8,
        }
    ]

};

export default menu;